import { Listbox } from '@headlessui/react';
import clsx from 'clsx';

import { Spinner } from './Spinner';
import { useReceptionists } from '../services/receptionists/useReceptionists';

export const ReceptionistSelector = () => {
  const { isLoading, receptionists, activeReceptionist, setActiveReceptionist } = useReceptionists();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (receptionists.length === 0) {
    return (
      <div className="flex items-center justify-center">
        <p className="text-error text-sm italic">Aucun réceptionniste configuré</p>
      </div>
    );
  }

  return (
    <Listbox value={activeReceptionist} onChange={setActiveReceptionist}>
      <div className="relative">
        <Listbox.Button className="relative flex items-center gap-x-2 h-full">
          <div className="bg-success rounded-full w-2 h-2" />
          <span className="truncate capitalize font-bold">{activeReceptionist?.toLocaleLowerCase()}</span>
        </Listbox.Button>

        <Listbox.Options className="absolute z-10 mt-1 max-h-60 max-w-xs right-0 overflow-auto rounded-md bg-background py-1 text-base shadow-lg shadow-shadow ring-1 ring-border ring-opacity-5 focus:outline-none sm:text-sm">
          {receptionists.map(receptionist => (
            <Listbox.Option
              key={receptionist}
              className={({ active }) =>
                clsx(active && 'bg-background_highlight', 'relative cursor-default select-none py-2 pl-3 pr-9')
              }
              value={receptionist}
            >
              {({ selected }) => (
                <>
                  <span className={clsx(selected ? 'font-semibold' : 'font-normal', 'block truncate capitalize')}>
                    {receptionist.toLocaleLowerCase()}
                  </span>
                </>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
};
